module.exports = __webpack_public_path__ + "img/Eo2.5b418516.jpg";